export const MAX_PAYMENT_TERM_DAYS = 9999
